import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { formatSwissNumber, getPostTypeString } from '../../../../utils';
import { SWISS_CURRENCY } from '../../../../utils/constant';
import { getCurrentImageSrc, handleImageError } from '../../../../utils/market';
import { getRonsTipsDetailsPageUrl } from '../../../../utils/ronsTips';
import Avatar from '../../Common/Avatar/Avatar';

const SearchSuggestions = ({ searchSuggestions, setShowPopover }) => {
  const router = useRouter();
  const { city } = router.query;
  const lang = useSelector(({ common }) => common?.language);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  return (
    <div className='divide-y'>
      {Array.isArray(searchSuggestions?.data) ? (
        searchSuggestions?.data.slice(0, 5).map((item) => (
          <Link
            key={item.id}
            href={
              router?.pathname.includes('/rons-tips')
                ? getRonsTipsDetailsPageUrl(item, city)
                : `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${getPostTypeString(
                    router?.pathname
                  )}/posts/${item.id}?city=${city}`
            }
          >
            <div
              onClick={() => {
                setShowPopover(false);
              }}
              className='flex cursor-pointer items-center px-[12px] py-2 hover:bg-gray-100'
            >
              {item?.image?.length > 0 && (
                <div
                  className={`relative mr-[21px] h-[64px] w-[64px] cursor-pointer`}
                >
                  <Image
                    src={getCurrentImageSrc(item, currentImageIndex)}
                    alt='Market post photo'
                    fill
                    className='object-cover'
                    sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
                    onError={() =>
                      handleImageError(
                        item,
                        currentImageIndex,
                        setCurrentImageIndex
                      )
                    }
                  />
                </div>
              )}
              <div className='flex w-full justify-between gap-4'>
                <div className='w-full'>
                  <p className='mb-0 line-clamp-1 w-full break-words text-[16px]'>
                    {item.title ||
                      item?.story?.title ||
                      item?.survey?.title ||
                      item?.event?.title ||
                      item?.phototrip?.title}
                  </p>
                  <div className='mb-[4px] flex items-center gap-[4px]'>
                    <span className='my-0 mb-0 mt-[2px] flex cursor-pointer text-[12px] uppercase text-[#B1B2B3]'>
                      {item?.discussion_type}
                    </span>
                    <span className='h-[2px] w-[2px] rounded-full bg-[#B1B2B3]'></span>

                    <div className='mb-0 mt-[2px] flex text-[12px]'>
                      <span
                        title={item?.category?.name}
                        className='my-0 line-clamp-1 w-[70px] cursor-pointer text-ellipsis text-[12px] text-mid'
                      >
                        {item?.category?.name}
                      </span>
                    </div>
                  </div>
                  <div className='flex items-center gap-[8px]'>
                    <Avatar
                      height='h-[16px] '
                      width='w-[16px] '
                      imagePath={item?.author_info?.profile_img?.path}
                      userName={item?.author_info?.name}
                    />
                    <p className='m-0 text-[14px] text-black'>
                      {item?.author_info?.name}
                    </p>
                  </div>
                </div>

                {router?.pathname?.includes('/market') && (
                  <p className='mb-0 w-[75px] text-[18px] font-semibold'>
                    {item?.price
                      ? `${SWISS_CURRENCY} ${formatSwissNumber(item?.price)}`
                      : 'N/A'}
                  </p>
                )}
              </div>
            </div>
          </Link>
        ))
      ) : (
        <div className='py-auto px-auto'>{lang?.common?.no_results_found}</div>
      )}
    </div>
  );
};

export default SearchSuggestions;
